'use strict';

var $                   = require('jquery');
var Core                = require('../core/core.js');
var ModalListSelectItem         = require('./modal__list__select__item.js');

/**
 * Creates a Tab
 *
 * @class
 */

class ModalList extends Core {

    _defaults() {
        return {
            target: '.js-modal',
            fields: {
                'title': '',
                'modal': false,
                'closeOnClick': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__modal__list'>
                <div class='editor__modal__top'>
                    <div class='editor__modal__top__title'><%- title %></div>
                    <div class='editor__modal__top__close'>
                        <div class='editor__modal__top__close__x js-editor__modal__top__close__x'><%= embedded_svg('icon-cancel') %></div>
                    </div>
                </div>
                <div class='editor__modal__list__body'>
                </div>
            </div>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires Modal#_clicked
         */
        $('.js-editor__modal__top__close__x', this.$el).on('click', this._closeClicked.bind(this));

        if(options.fields.modal) {
            this.$overlay = $("<div class='editor__modal__bg-overlay'></div>").appendTo(this.$el.parent());
            if(options.fields.closeOnClick) $('.editor__modal__bg-overlay', this.$el.parent()).on('click', this._closeClicked.bind(this));
        }
    }

    /**
     * @returns {Object} event - native click Event
     */

    _closeClicked(e){
        e.preventDefault();
        this.$el.trigger('Cioui:ModalList:close:clicked', e);
    }

    /**
     * add item to the list
     *
     */
    addSelectableItem(item){
        return new ModalListSelectItem({
            target: $(".editor__modal__list__body", this.$el),
            fields: {
                'item': item
            }
        });
    }

    /**
     * remove modal
     *
     */
    remove() {
        if(this.$overlay) this.$overlay.remove();
        this.$el.remove();
    }

}
module.exports = ModalList;